import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import { PosSync } from '@/interfaces/models/PosSync';
import { Pagination } from '@/interfaces/api/Pagination';
import { Page } from '@/interfaces/api/Page';
import Filter from '@/interfaces/api/Filter';
import { SimphonySyncMode } from '@/enums/SimphonySyncMode';

export default class SimphonyApiService extends ApiService<any> {
  constructor() {
    super('simphony', 'v2');
  }

  public syncFoodcard(payload: { venue: string; mode: SimphonySyncMode; v2?: boolean }): AxiosPromise<void> {
    return axios.put(`${this.getBaseUrl()}/foodcards/sync`, {
      mode: payload.mode,
      v2: payload.v2,
      venue: payload.venue,
    });
  }

  public refreshCnc(payload: { venue: string }): AxiosPromise<void> {
    return axios.put(`${this.getBaseUrl()}/cnc/${payload.venue}/cnc-refresh`);
  }

  public getPosSyncs(page: Page, filter: Filter): AxiosPromise<PosSync[] | Pagination<PosSync>> {
    if (page) {
      return axios.get(`${this.getBaseUrl()}/foodcards/sync/jobs`, {
        params: { page, ...filter },
      });
    }

    return axios.get(`${this.getBaseUrl()}/foodcards/sync/jobs`, { params: filter });
  }
}
